import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info-solid",
  "use": "info-solid-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"info-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M11 0a11 11 0 1011 11A11 11 0 0011 0zm1 15a1 1 0 01-2 0v-4a1 1 0 012 0zm-.3-7.3a1 1 0 01-1.4-1.4 1 1 0 011.4 1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol